<template>
  <v-container 
    fluid
    :fill-height="fillHeight"
    >
    <div id="app" class="mt-6 ml-6">
      <router-link to="/">
        <v-img 
        src="../assets/InTheSuburbs-small.png"
        href="/"
        max-width="200"
        alt="InTheSuburbs.com.au"
      ></v-img>
      </router-link>
  </div>

    <v-row align="center" justify="center">
      <v-col align="center">
      <v-toolbar
        elevation='24'
        rounded
        dark
        color="light-blue darken-4"
        max-width="400"
      >
        <v-autocomplete
          v-model="selectedSuburb"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          flat
          hide-no-data
          hide-details
          label="Suburb search"
          solo-inverted
          @change="suburbSelected(true)"
        ></v-autocomplete>
        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    </v-row>
  
    <div class="container">
    <div> 
      <Post :post="suburbsFullshow" />
    </div>
  </div>
  
 </v-container>

</template>

<script>
  import suburbsList from '../assets/suburbs_min.json'
  import Post from '../components/SuburbDetails.vue'
  import axios from 'axios';

  export default {
    name: 'Suburbs',

    data () {
      return {
        suburbsList: suburbsList,
        suburbsFullshow: null,
        suburbName: '',
        suburbPostcode: '',
        loading: false,
        items: [],
        search: null,
        select: null,
        selectedSuburb: null,
        fillHeight: true,
        pageTitle: '',
        pageMeta: [],
        info: null
      }
    },

    components: {
      Post
    },
    props: ['query'],
    setup(props) {
      const suburbRaw = props.query.name
      const suburb = suburbRaw.replace(/\+/g, " ")
      return {
          suburb
        }
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
    },
    methods: {
      querySelections (v) {
        this.loading = true
        // Simulated ajax query
        setTimeout(() => {
          this.items = this.suburbsList.filter(e => {
            return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
          this.loading = false
        }, 500)
      },
      async suburbSelected(refresh) {
        this.suburbName = this.selectedSuburb.split(',')[0]
        this.suburbPostcode = this.selectedSuburb.split(' ').pop()  

        const config = {
            headers: { 'x-api-key': 'zyzPFP82lR55fO8uI7hhM3ghJlm6TqTc6nKijcsc' }
        };

        this.info = await axios.get(
                    'https://api.inthesuburbs.com.au?postcode='+this.suburbPostcode+'&suburb='+this.suburbName,
                    config
                    ).then()
     
        this.fillHeight = false


        
        this.suburbsFull = this.info.data


        this.schools = await axios.get(
                    'https://api.inthesuburbs.com.au/schools?postcode='+this.suburbPostcode,
                    config
                    ).then()

        this.suburbsFull['schools'] = this.schools.data

        this.suburbsFullshow = this.suburbsFull


        if (refresh == true) {
          this.$router.push('/suburb?name='+this.selectedSuburb)
        }

      },
    },
    mounted() {
      this.selectedSuburb = this.suburb
      this.pageTitle = ('Suburb Details: '+this.selectedSuburb),
      this.pageMeta = [
                    {
                        name: 'description',
                        content: 'All about ' + this.suburb + '  - Demographic data, map, shops and more'
                    },
                    {
                        property: 'og:description',
                        content: 'All about ' + this.suburb + '  - Demographic data, map, shops and more'
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        content: 'All about ' + this.suburb + '  - Demographic data, map, shops and more'
                    },
                    {
                        property: 'og:image',
                        content: 'https://www.inthesuburbs.com.au/suburb?name='+this.selectedSuburb
                    },
                    {
                        property: 'og:url',
                        content: 'https://www.inthesuburbs.com.au/img/InTheSuburbs-small.6f986745.png'
                    }
                  ];
      this.suburbSelected(false)
  }
  }
</script>
